import HttpService from '../../../core/rest/http.service';
export async function loadWhispererSearch({ endpoint, query, structureKeys, showSiteUrl, groupId }) {
    if (typeof query === "string" && query.length === 0 || query === null) {
        // eslint-disable-next-line @typescript-eslint/no-unsafe-return
        return Promise.resolve([]);
    }
    const parameters = {
        q: query,
        structureKeys,
        showSiteUrl,
        groupId,
        page: 1,
        pageSize: 5
    };
    // eslint-disable-next-line @typescript-eslint/no-unsafe-return
    return HttpService.get(endpoint, parameters).then(({ results }) => results);
}
export async function loadSearch({ endpoint, query, type, structureKeys, showSiteUrl, groupId, pager }) {
    const parameters = {
        q: query,
        type: type || undefined,
        structureKeys,
        showSiteUrl,
        groupId,
        page: pager.page,
        pageSize: pager.perPage
    };
    Object.entries(parameters).forEach(([key, value]) => {
        if (value === undefined)
            delete parameters[key];
    });
    // eslint-disable-next-line @typescript-eslint/no-unsafe-return
    return HttpService.get(endpoint, parameters);
}
